module.exports = __webpack_public_path__ + "img/logo_uniratka_blue.f0e6c275.svg";